<app-base-modal dialogTitle="Add incident" (closeEvent)="onCancel()">
  <div class="modal-hint">
    Enter the source URL. The name is optional and used for display. It may take a few moments for the reference to
    appear as attached.
  </div>

  <form [formGroup]="formGroup">
    <div>
      <mat-form-field appearance="outline" floatLabel="always" style="width: 100%">
        <mat-label>Article Reference Name</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" style="width: 100%">
        <mat-label>Article Reference URL</mat-label>
        <textarea matInput cdkTextareaAutosize formControlName="url" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="10">
        </textarea>
        @if (formGroup.get('url')?.hasError('required')) {
          <mat-error> URL is required </mat-error>
        }
        @if (formGroup.get('url')?.hasError('invalidSyntaxUrl')) {
          <mat-error> Enter a valid URL </mat-error>
        }
        @if (formGroup.get('url')?.hasError('nonUniqueUrl')) {
          <mat-error> URL already added as a reference </mat-error>
        }
      </mat-form-field>
    </div>
  </form>

  <!-- This is projected by the ng-content of the app-base-modal -->
  <div panel-footer>
    <button mat-flat-button class="button-link" (click)="onCancel()">Cancel</button>
    <button mat-flat-button class="button-primary" (click)="onContinue()" [disabled]="formGroup.invalid">
      Add article reference
    </button>
  </div>
</app-base-modal>
